import { render, staticRenderFns } from "./AccrualUser.vue?vue&type=template&id=60a733d8&scoped=true"
import script from "./AccrualUser.vue?vue&type=script&lang=js"
export * from "./AccrualUser.vue?vue&type=script&lang=js"
import style0 from "./AccrualUser.vue?vue&type=style&index=0&id=60a733d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a733d8",
  null
  
)

export default component.exports